import { getRuntimeConfig } from '@nucleus-commerce/admin-kit/config';

const LOCAL_ADMIN_APP_URL = 'http://localhost:5173';

/**
 * Where the tenant admin app lives; support sessions open there in a new tab. Null when a
 * deployed config leaves it out, so the console can say so instead of opening a wrong origin.
 */
export function adminAppUrl(): string | null {
  const { adminAppUrl: configured, env } = getRuntimeConfig();
  if (configured) return configured;
  return env === 'development' ? LOCAL_ADMIN_APP_URL : null;
}
